export function dateConv(date) {
    const converter = new Date(date); // M-D-YYYY
    const d = converter.getDate();
    const m = converter.getMonth() + 1;
    const y = converter.getFullYear();
    return y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}
